import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, Dialog } from '@material-ui/core';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .textField2': {
        width: '45%',
        marginRight: '30px',
        backgroundColor: '#FFFFFF',
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .textWapper2': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.13',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class ReferralInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: "",
            numberCopy: "",
            name: "",
            note: "",
            openPass: false,

            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handlePass = this.handlePass.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDialogCancel = this.handleDialogCancel.bind(this);
    }
    render() {
        const {
            openPass,
        } = this.state;
        return (
            <Root>
                <div className="pageTitle">YOU RECEIVE A REFERRAL</div>
                <div className="line"></div>
                <div className="title">Case Info</div>
                <div className="flow">
                    <div className="textWapper2">
                        <div className="textTitle">Type of case</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={timeFormat2(dataInfo["S.DOB"])}
                            // onChange={e => this.handleChange(e, 'S.DOB')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="textWapper2">
                        <div className="textTitle">Client name</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="textWapper2">
                        <div className="textTitle">Client email</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="textWapper2">
                        <div className="textTitle">Client phone number</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="textWapper">
                        <div className="textTitle">Client Note</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textFieldF"
                            multiline
                            rows="3"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className="title">Referral Info</div>
                <div className="flow">
                    <div className="textWapper2">
                        <div className="textTitle">Date of Referral</div>
                        <TextField
                            type="date"
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={timeFormat2(dataInfo["S.DOB"])}
                            // onChange={e => this.handleChange(e, 'S.DOB')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="textWapper2">
                        <div className="textTitle">Referee</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            className="textField"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="refealBtn" variant="contained" onClick={this.handlePass}>PASS THIS REFERAL</Button>
                    <Button variant="contained" color="primary" onClick={this.handleCreate}>CONFIRM TO RECEIVE</Button>
                </div>
                <Dialog maxWidth={false} open={openPass}>
                    <div className="passWapper c" style={{ width: "800px", padding: "30px 20px" }}>
                        <div style={{
                            color: "#0060A0",
                            fontWeight: "bold",
                        }}>PLEASE TYPE THE REASON YOU PASSED THIS REFERAL</div>
                        <TextField
                            // disabled={this.isDisabled()}
                            style={{ width: "100%", padding: "20px 20px 0 20px" }}
                            placeholder="Type here…"
                            multiline
                            rows="5"
                            // value={dataInfo["P.SSN.L4"]}
                            // onChange={e => this.handleChange(e, 'P.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                        />
                        <div style={{
                            width: '100%',
                            height: '1px',
                            backgroundColor: '#A1A1A1',
                            margin: '20px 0',
                            opacity: '0.13',
                        }}></div>
                        <div className="h h-r" style={{ width: "100%" }}>
                            <Button style={{ marginRight: "20px" }} variant="contained" onClick={this.handleDialogCancel}>CANCEL</Button>
                            <Button variant="contained" color="primary" onClick={this.handleCreate}>SUBMIT</Button>
                        </div>
                    </div>
                </Dialog>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        console.log(data)
        if (state === VIEW || state === EDIT) {
            const number = data.number;
            const numberCopy = data.number;
            const name = data.name;
            const note = data.note ? data.note : "";
            this.setState(() => ({
                number,
                numberCopy,
                name,
                note,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleDialogCancel(e) {
        this.setState(() => ({
            openPass: false
        }))
    }
    handleCreate() {
        const { caseId } = this.props;
        const {
            number,
            numberCopy,
            name,
            note,
        } = this.state;
        let teamObj = this.levelChoose.getData();
        let userObj = {};
        userObj.handler_id = teamObj.handler_id;
        userObj.handler_team_id = teamObj.handler_team_id;
        userObj.is_origin_attorney = true;
        const attorneyArr = [userObj];
        const asObjFormat = this.editAttorney(attorneyArr);//结构：{addHandler,delHanlder}
        const psObjFormat = this.participate.getData();//结构：{addMembers,delMembers}
        const handlers = this.mergeHandlers(asObjFormat, psObjFormat);
        let obj = {
            case_id: caseId,
            number: (number !== numberCopy) ? number : null,
            name,
            note,
            handlers,
        }
        this.props.handleCreate(obj);
    }
    mergeHandlers(attorneyArr, participantArr) {
        const aAddMembers = attorneyArr.addHandler;
        const pAddMembers = participantArr.addMembers;
        const aDelMembers = attorneyArr.delHandler;
        const pDelMembers = participantArr.delMembers;
        const addMembers = aAddMembers.concat(pAddMembers);
        const delMembers = aDelMembers.concat(pDelMembers);
        return { addMembers, delMembers };
    }
    editAttorney(handler) {
        const addHandler = handler;
        const delHandler = this.extDelAttorney();
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = (delHandler.length > 0) ? delHandler[0].handler_id : "";
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = (delHandler.length > 0) ? delHandler[0].handler_team_id : "";
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                return { addHandler: [], delHandler: [] };
            } else {
                return { addHandler, delHandler }
            }
        }
    }
    extDelAttorney() {
        const { data } = this.props;
        if (!data) return [];
        const handlers = data.handler;
        if (!handlers) return [];
        let handlerObj = [];
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                let newObj = {};
                newObj.handler_id = obj.user.id;
                newObj.handler_team_id = obj.team.id;
                newObj.is_origin_attorney = obj.is_origin_attorney;
                handlerObj.push(newObj);
                return handlerObj;
            }
        }
        return [];
    }
    handlePass() {
        this.setState(() => ({
            openPass: true
        }))
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const obj = handlers[0];
        const userObj = obj.user;
        const deptObj = obj.team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        } else if (name === "view") {
            return obj;
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.handler;
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
    closeDialog() {
        this.setState(() => ({
            openPass: false
        }))
    }
}

export default ReferralInfo;